module.exports = __webpack_public_path__ + "img/button.b1cf9901.png";